import {
  Flex,
  Hide,
  SortDownIcon,
  SortUpIcon,
  Typography,
} from '@iheartjane/reefer';
import { clsx } from 'clsx';
import type { ReactNode } from 'react';
import { useState } from 'react';

import styles from './expandableNav.module.css';

export const ExpandableNav = ({
  children,
  title,
}: {
  children: ReactNode;
  title: string;
}) => {
  const [isHidden, setIsHidden] = useState(false);
  return (
    <>
      <Flex
        className={clsx(styles['header'], {
          [styles['header--collapsed']]: isHidden,
        })}
        ariaLabel={title}
        onClick={() => setIsHidden(!isHidden)}
      >
        {isHidden ? <SortUpIcon /> : <SortDownIcon />}
        <Typography ml={8} variant="body-semibold">
          {title}
        </Typography>
      </Flex>
      <Hide isHidden={isHidden}>{children}</Hide>
    </>
  );
};
